export enum BugReportReason {
  VIDEO = 'video',
  AUDIO = 'audio',
  CALLER_TEXT = 'callerText',
  EMERGENCY = 'emergency',
  DIALPAD = 'dialpad',
  TEAMING = 'teaming',
  HANDOFF = 'handoff',
  OTHER = 'other',
}
